import {Component, OnInit} from '@angular/core';
import {StorageS}                                       from '../service/storage';
import {CommonHelper}                                   from '../service/common-helper';
import {MessageService}                                 from '../service/message.service';

export interface RouteInfo{
	path: string;
	title: string;
	icon: string;
	class: string;
}

export const ROUTES: RouteInfo[] = [
	{path: '/admin/dashboard', title: 'Dashboard', icon: 'nc-bank', class: ''},
	{path: '/admin/brand', title: 'Brand', icon: 'nc-app', class: ''},
	{ path: '/admin/review', title: 'Review', icon: 'nc-chat-33', class: '' },

	{path: '/admin/category', title: 'Category', icon: 'nc-badge', class: ''},
	{path: '/admin/service-category', title: 'Service Category', icon: 'nc-badge', class: ''},
	{path: '/admin/product', title: 'Product', icon: 'nc-shop', class: ''},
	{path: '/admin/service', title: 'Service', icon: 'nc-shop', class: ''},
    {path: '/admin/attribute', title: 'Attribute', icon: 'nc-shop', class: ''},
    {path: '/admin/attribute-values', title: 'Attribute Values', icon: 'nc-shop', class: ''},
	// {path: '/admin/testimonial', title: 'Testimonial', icon: 'nc-book-bookmark', class: ''},
	// {path: '/admin/policy', title: 'Policy', icon: 'nc-bulb-63', class: ''},
	{path: '/admin/customer', title: 'Customer', icon: 'nc-credit-card', class: ''},
//   {path: '/admin/subscriber', title: 'Subscriber', icon: 'nc-credit-card', class: ''},
	// {path: '/admin/seller-requests', title: 'Seller Request', icon: 'nc-paper', class: ''},
	{path: '/admin/inquiry', title: 'Enquiry', icon: 'nc-check-2', class: ''},
	{path: '/admin/orders', title: 'Orders', icon: 'nc-money-coins', class: ''},
	{path: '/admin/general-report', title: 'Reports', icon: 'nc-bookmark-2', class: ''},
	{path: '/admin/vendor', title: 'Vendor', icon: 'nc-support-17', class: ''},
	{path: '/admin/coupon', title: 'Coupon', icon: 'nc-favourite-28', class: ''},
	{path: '/admin/slider', title: 'Slider', icon: 'nc-tile-56', class: ''},
	{path: '/admin/banner', title: 'Banner', icon: 'nc-image', class: ''},
	{path: '/admin/user', title: 'My Profile', icon: 'nc-single-02', class: ''},
	// {path: '/admin/website-details', title: 'Website Details', icon: 'nc-globe', class: ''},
];

export const VENDOR_ROUTES: RouteInfo[] = [
	{path: '/vendor/dashboard', title: 'Dashboard', icon: 'nc-bank', class: ''},
	{path: '/vendor/product', title: 'Product', icon: 'nc-shop', class: ''},
	{ path: '/vendor/reviews', title: 'Review', icon: 'nc-chat-33', class: '' },
	{path: '/vendor/inquiry', title: 'Enquiry', icon: 'nc-check-2', class: ''},
	{path: '/vendor/service', title: 'Service', icon: 'nc-money-coins', class: ''},
	{path: '/vendor/orders', title: 'Orders', icon: 'nc-money-coins', class: ''},
	{path: '/vendor/general-report', title: 'Reports', icon: 'nc-bookmark-2', class: ''},
	{path: '/vendor/user', title: 'User Profile', icon: 'nc-single-02', class: ''},
];

@Component({
	           moduleId   : module.id,
	           selector   : 'sidebar-cmp',
	           templateUrl: 'sidebar.component.html',
	           styleUrls  : ['sidebar.component.scss'],
           })

export class SidebarComponent implements OnInit{
	
	public menuItems: any[];
	public AdminData = JSON.parse(localStorage.getItem('AdminData'));
	public userData: any;
	public tableList: any;

	constructor(private storageS: StorageS,private messageService: MessageService) { }
	ngOnInit(){
		 console.log('AdminData from localStorage:', this.AdminData);
        CommonHelper.fetchById(this.AdminData.id, this, 'user').then((data) => {
			this.userData = data;
			  this.profileImage = this.ParseImage(this.userData?.zf);

  console.log('SIDEBAR PROFILE IMAGE:', this.profileImage);
	     });

		/*if(this.AdminData.type==1){
			this.menuItems = ROUTES.filter(menuItem => (menuItem.title !=='Banner'));
		} else if(this.AdminData.type==2){
			this.menuItems = VENDOR_ROUTES.filter(menuItem =>  (menuItem.title !=='Banner'));
		}*/

if (this.AdminData.type === 1) {

  // ADMIN
  this.menuItems = ROUTES.filter(
    menuItem => menuItem.title !== 'Banner'
  );

} 
else if (this.AdminData.type === 2) {

  // VENDOR
  this.menuItems = VENDOR_ROUTES.filter(menuItem => {

    // 🚫 hide Product & Service if not subscribed
    if (
      this.AdminData.is_subscribed === 0 &&
      (menuItem.title === 'Product' || menuItem.title === 'Service')
    ) {
      return false;
    }

    return true;
  });

}


	}

	async fetchById(id){
        
		await CommonHelper.fetchById(id, this, 'user');
		
	}
	
public profileImage: string = '';

ParseImage(zf: any): string {
  if (!zf) return '';

  // If string → parse once
  if (typeof zf === 'string') {
    try {
      zf = JSON.parse(zf);
    } catch {
      return '';
    }
  }

  if (!Array.isArray(zf) || !zf.length) return '';

  // Prefer active image
  const img = zf.find(i => i?.a === 1) || zf[0];
  if (!img?.nm) return '';

  const url = img.url || '';

  // ✅ FULL URL → return as-is
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  // ✅ ONLY uploads/user/ → fix using filename
  const cleanUrl = url.replace(/^\/+/, '').replace(/\/+$/, '');
  if (cleanUrl === 'uploads/user') {
    return `https://kadaikoditech.com:4000/uploads/user/${img.nm}`;
  }

  // ❌ Unknown case → no image
  return '';
}


}
